import React, { Fragment, useEffect, useState } from "react";
import { colorsColumn } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import {useDispatch, useSelector} from "react-redux";
import Translator from "Languages/Utility/Translator";
import cellEditFactory from "react-bootstrap-table2-editor";
import {read} from "Helpers/LocalStorage";
import {editNameColor, getAllTypeAndColor} from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

function ProfileTable({ data }) {
  const { allTypeColorsPagination } = useSelector((state) => ({
    allTypeColorsPagination: state.profile.allTypeColorsPagination,
  }));
  const [tblData, setTblData] = useState(data);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setTblData(data);
  }, [data, allTypeColorsPagination]);

  const BeforeSaveCell = async (oldValue, newValue, row, column, done) => {
      if (oldValue !== newValue && column.dataField === "NameColor") {
          try {
              setLoading(true);
              const data = {
                  KeyGroup: read("groupKey"),
                  KeyUser: read("userKey"),
                  Name: newValue,
                  Id: row.IdColor,
                  ColorPattern: row.ColorPattern.Id
              };
              await dispatch(editNameColor(data));
              const params = {
                  KeyGroup: read("groupKey"),
                  KeyUser: read("userKey"),
              };
              await dispatch(getAllTypeAndColor(params));
              setLoading(false);
          } catch (e) {
              setLoading(false);
          }
      }
      else {
          done(false);
      }
  };
  
  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <RemoteTable
        data={tblData}
        keyField="IdColor"
        columns={colorsColumn}
        loading={loading}
        title={<Translator id={"listColors"}/>}
        showPagination={false}
        page={1}
        sizePerPage={tblData.length}
        totalSize={tblData.length}
        // onTableChange={() => {}}
        cellEdit={cellEditFactory({
          mode: "click",
          blurToSave: true,
          beforeSaveCell: (oldValue, newValue, row, column, done) =>
              BeforeSaveCell(oldValue, newValue, row, column, done),
        })}
      />
    </Fragment>
  );
}

export default ProfileTable;
